import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  props: {
    shadowRoot: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_metainfo = _resolveComponent("metainfo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_router_view, {
        "shadow-root": _ctx.shadowRoot || null
      }, null, 8, ["shadow-root"])
    ]),
    _createVNode(_component_metainfo, null, {
      title: _withCtx((content) => [
        _createTextVNode(_toDisplayString(content?.metainfo?.title) + " - " + _toDisplayString(_ctx.$t('title')), 1)
      ]),
      _: 1
    })
  ], 64))
}
}

})